module.exports = __webpack_public_path__ + "img/Logo.c00a67f3.png";